import React, { useEffect, useMemo, useCallback, useState } from 'react';

import { useSelector } from 'react-redux';

import StockDetail from "Components/StockDetail";
import DialogPortal from "Components/DialogPortal";

const AutoLink = ({ text, setParentBlockShortCut }) => {
  const [stockDetailData, setStocDetailData] = useState(null);
  const stockCodeMap = useSelector(state => state.stock.stockCodeMap);
  const nameMap = stockCodeMap.nameMap;

  const regexUrl = useMemo(()=>/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,[])
  const regexStockName = useMemo(()=>{
    return new RegExp('('+Object.keys(nameMap).join('|')+')','g')
  },[nameMap]);


  const handleClickStock = useCallback((name, code) => {
    setStocDetailData({
      cd: code,
      nm: name,
    })
  },[]);


  const stockFilter = useCallback(text => {
    // return text;

    if (!text) {
      return null;
    }

    return text.split(regexStockName).map((piece, index) => {
      if (!nameMap[piece]) {
        return piece;
      }

      return (<button key={piece+'_'+index} type="button" className="stockView fc_red" onClick={handleClickStock.bind(null, piece, nameMap[piece])}>{piece}</button>)
    });
  },[regexStockName, nameMap, handleClickStock]);


  useEffect(() => {
    if (setParentBlockShortCut) {
      setParentBlockShortCut(stockDetailData ? true : false)
    }
  }, [stockDetailData, setParentBlockShortCut]);

  /* url 텍스트는 a 링크로 변경 */
  const domResult = useMemo(()=>{
    if (!text) {
      return null;
    }

    return text.split(regexUrl).map((piece, index) => {
      if (!regexUrl.test(piece)) {
        return stockFilter(piece);
      }

      const url = piece.indexOf('http') !== 0 ? '//'+piece : piece;
      return (<a key={url+'_'+index} href={url} target="_blank" rel="noreferrer">{piece}</a>)
    });
  },[text, regexUrl, stockFilter]);


  const domPopupStockDetail = useMemo(()=>{
    if (!stockDetailData) {
      return null;
    }

    return (
      <DialogPortal>
        <StockDetail stockDetail={stockDetailData} callback={setStocDetailData.bind(null, null)} />
      </DialogPortal>
    )
  },[stockDetailData])

  return (
    <>
      {domResult}
      {domPopupStockDetail}
    </>
  )
}

export default AutoLink;